import LocalStorage from '@/library/localStorage';
import {importWrapper} from '@/library/utils';
import {sendPopupRequest} from '../utils/portuna';
import {Popup} from './popup';

const BookmarkEditPopup = importWrapper(() => import('../views/bookmark/BookmarkEditPopup.vue'));
const BookmarkListPopup = importWrapper(() => import('../views/bookmark/BookmarkListPopup.vue'));

function openBookmarkAfterReload()
{
    LocalStorage.set('bookmarkForceOpen', true);
}

export function bookmarkEditPopup(entry: BookmarkEntry)
{
    BookmarkEditPopup().then(Component =>
    {
        let popup = new Popup({
                title: entry.id ? 'Lesezeichen bearbeiten' : 'Lesezeichen hinzufügen',
                titleIcon: 'star',
                size: 'small',
                buttons: [],
                component: Component.default,
                componentProps: {bookmarkEntry: entry},
            },
        );

        popup.open();
    });
}

export function bookmarkList()
{
    BookmarkListPopup(openBookmarkAfterReload).then(Component =>
    {
        let popup = new Popup({
                component: Component.default,
                title: 'Lesezeichen',
                titleIcon: 'article',
                size: 'small',
                position: 'right',
                height: 'full',
                buttons: [],
                closeOnClickOutside: true,
                customScrollBar: false,
            },
        );

        popup.open();
    });
}

export function bookmarkDeletePopup(bookmark: BookmarkEntry)
{
    return new Promise((resolve, reject) =>
    {
        sendPopupRequest({
            type: 'delete',
            url: '/application/bookmark/delete-bookmark',
            data: {
                id: bookmark.id,
            },
            message: {
                headline: 'Lesezeichen löschen',
                message: `Sind Sie sicher, dass Sie das <strong>Lesezeichen \"${bookmark.title}\"</strong> löschen möchten?`,
            },
            options: {
                buttonOkay: Object.assign({
                    title: 'Löschen',
                    icon: 'delete',
                    type: 'danger',
                }),
                titleIcon: 'delete',
                textIcon: 'delete_forever',
                textIconClass: 'text-danger',
            },
        })
        .then(resolve)
        .catch(reject);
    });
}